import axios from "axios";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_AUTH_URL;
//const API_URL = "https://backend.kulmasohva.com:8080/api/auth/";

axios.defaults.withCredentials = true;

class AuthService {
  login(username: string, password: string) {
    return axios
      .post(
        API_URL + "signin",
        {
          username,
          password,
        },
        { withCredentials: true }
      )
      .then((response) => {
        console.log("Login response!:", response.data)
        return response.data;
      })
      .catch((error) => {
        toast.error("Login failed:" + error, { position: "bottom-right" });
        return error;
      });
  }

  logout() {
    return axios.post(API_URL + "signout");
  }

  register(username: string, email: string, password: string) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password,
    });
  }

  getCurrentUser = async () => {
    try {
      const fetchUser = await fetch(API_URL + "me", {credentials: "include"})
      if (!fetchUser.ok) {
        // Handle unauthorized or other errors
        throw new Error(`HTTP error! Status: ${fetchUser.status}`);
      }
      const userData = await fetchUser.json();
      console.log("User data:", userData);
      return userData;
    } catch (error) {
      console.error('Error fetching user:', error);
      toast.error("Login failed:" + error, { position: "bottom-right" });
      throw error; // Re-throw to handle the error in your component
    }
  };

  isAuthenticated() {
    console.log(this.getCurrentUser())
    return this.getCurrentUser().then((user) => !!user);
  }
}

const authService = new AuthService();
export default authService;
